module.exports = __webpack_public_path__ + "static/img/119a103.74fb9ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/rollImg/rollSale/119a103.jpg
// module id = nZv/
// module chunks = 0